import { Box, Typography } from "@mui/material";
import { Lead } from "@/modules/leads/types";
import { useState, useCallback } from "react";
import SingleSelectSearch from "@/modules/common/components/input/single-autocomplete-search";

interface AssignedUserOption {
  value: number;
  label: string;
  color: string;
}

interface EditAssignedUserProps {
  assignedUser: {
    handleChangeAssignedUser: (value: string) => void;
    data: any;
    value: string | undefined;
    usersSearchTerm: string;
    setUsersSearchTerm: (value: string) => void;
    usersLoading: boolean;
  };
  lead: { data: { lead: Lead } } | undefined;
  autoFocus?: boolean;
}

const EditAssignedUser = ({ assignedUser, lead }: EditAssignedUserProps) => {
  const [selectedUserId, setSelectedUserId] = useState<string | undefined>(
    assignedUser.value || lead?.data?.lead?.user?.id
  );

  const isLeadInvalid = lead?.data?.lead?.rubbish === true;

  const options: AssignedUserOption[] =
    assignedUser.data?.map(
      (option: {
        id: string;
        name: string;
        color: string;
        tags?: string[];
        configuration?: { isAvailable?: boolean };
      }) => {
        const label = option.name;
        const color = option.color;

        return {
          label,
          color,
          value: option.id,
        };
      }
    ) || [];

  const handleChange = useCallback(
    (value: string | null) => {
      setSelectedUserId(value ?? undefined);
      assignedUser.handleChangeAssignedUser(value ?? "");
    },
    [assignedUser]
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {isLeadInvalid && (
        <Typography variant="body2" color="warning.main" sx={{ mb: 1 }}>
          Please mark the lead as a Valid client before assigning
        </Typography>
      )}
      <SingleSelectSearch
        options={options}
        isLoading={assignedUser.usersLoading}
        label="Assigned User"
        value={selectedUserId}
        onValueChange={handleChange}
        searchValue={assignedUser.usersSearchTerm}
        onSearchValueChange={assignedUser.setUsersSearchTerm}
        disabled={isLeadInvalid}
      />
    </Box>
  );
};

export default EditAssignedUser;
